// JsFromRoutes CacheKey 8787827a56bbd4783b99f7e62d5e515a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  approveMemberInvoice: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/approve_member_invoice'),
  block: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/block'),
  pause: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/pause'),
  readyToPay: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/ready_to_pay'),
  runBillingForEmployer: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/run_billing_for_employer'),
  unApproveMemberInvoice: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/un_approve_member_invoice'),
  payFromThatchOperating: /* #__PURE__ */ definePathHelper('post', '/admin/employer_invoices/:employer_invoice_id/pay_from_thatch_operating'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/employer_invoices'),
  new: /* #__PURE__ */ definePathHelper('get', '/admin/employer_invoices/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/employer_invoices/:id'),
}
